import baseUrl from './base';

export const postLogicielFacturier = () => `${baseUrl}/logicielsFacturier`;

export const putLogicielFacturier = (id: number) => `${baseUrl}/logicielsFacturier/${id}`;
